import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { CHECKOUT_URL } from '../data/product';
export function Close() {
  return <section className="w-full border-y-4 border-gold bg-navy" data-id="element-49" data-mp="1zvl8uujupydw">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-50" data-mp="1uwrs8t99pr9i">
        <h2 className="font-display font-bold uppercase text-white text-3xl sm:text-5xl" data-id="element-51" data-mp="1q01ck71dkxom">
          Stop improvising. <span className="text-gold" data-id="element-52" data-mp="1l16uj7b8fd5k">Start coaching from a system.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-white/75" data-id="element-53" data-mp="1g96p4zce7s1l">
          Six volumes, 136 Session Cards — lessons, clinics and season programs
          built with The Four-Block Session. Every player moving, every level on
          the same court. Ready to print and run.
        </p>

        <div className="mt-7" data-id="element-54" data-mp="12a74s3vwxzb8">
          <Countdown size="sm" tone="dark" data-id="element-55" data-mp="1295qzrniiypt" />
        </div>

        <div className="mx-auto mt-6 flex max-w-lg flex-wrap items-center justify-between gap-3 rounded-2xl border border-gold bg-gold/10 px-5 py-4 text-left" data-id="element-56" data-mp="xa2ke2rvwkfq">
          <div data-id="element-57" data-mp="3vdc0o0hzogn6">
            <span className="block text-[10px] font-bold uppercase tracking-widest text-gold" data-id="element-58" data-mp="40r21fjuqw3n">Complete package</span>
            <span className="text-[15px] font-bold text-white" data-id="element-59" data-mp="3lhr3qgrs26ka">Court Ready — 6 Volumes + 5 Bonuses</span>
          </div>
          <div className="flex items-baseline gap-2.5" data-id="element-60" data-mp="3qhdgkp3p1ksk">
            <span className="text-[15px] text-white/60 line-through" data-id="element-61" data-mp="3qdzgxomezpot">$97</span>
            <span className="font-display text-4xl leading-none text-white" data-id="element-62" data-mp="i1ab8q02087e">$27</span>
          </div>
        </div>

        <div className="mx-auto mt-5 max-w-lg" data-id="element-63" data-mp="mx91yk8uu2az">
          <CtaButton href={CHECKOUT_URL} data-id="element-64" data-mp="81b14onzk9sf">Yes, I want Court Ready — $27</CtaButton>
        </div>

        <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/60" data-id="element-65" data-mp="d0e6ka7voi0x">
          {['Secure checkout', 'Instant access', '7-day guarantee'].map(item => <li key={item} className="flex items-center gap-2" data-id="element-66" data-mp="2xs6a93xzzqwr">
              <span className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-67" data-mp="2xpaada2las5o" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}